import { useEffect } from "react";

import { useEnvironmentUnsafe } from "@/common/contexts/EnvironmentContext";
import { initIntercom } from "@/common/utils/intercom";

export function IntercomIdentity() {
  const intercomUserJwt = useEnvironmentUnsafe()?.intercomUserJwt;
  useEffect(() => {
    if (!intercomUserJwt) {
      return;
    }
    initIntercom(intercomUserJwt);
  }, [intercomUserJwt]);

  return null;
}
